import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Review } from '../../../models/Review';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { RestStop, RestStopDetails } from '../../../models/rest-stop';

@Component({
  selector: 'app-review-list',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule],
  templateUrl: './review-list.component.html',
  styleUrls: ['./review-list.component.scss'],
})
export class ReviewListComponent {
  @Input() reviews: Review[] = [];
  @Input() filteredReviews: Review[] = [];
  @Input() restStop?: RestStop;

  private router = inject(Router);

  getStarArray(rating: number): string[] {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= rating) {
        stars.push('star');
      } else {
        stars.push('star_border');
      }
    }
    return stars;
  }

  navigateToUser(userId: string): void {
    this.router.navigate(['/user', userId]);
  }

  buildNoReviewsMessage(): string {
    const name = this.restStop?.name || 'Diese Raststätte';
    const details: RestStopDetails | undefined = this.restStop?.details;
    const amenityMap: { key: keyof RestStopDetails; label: string }[] = [
      { key: 'wifi', label: 'WLAN' },
      { key: 'playground', label: 'Spielplatz' },
      { key: 'chargingStation', label: 'Ladesäule' },
      { key: 'restaurant', label: 'Restaurant' },
      { key: 'gasStation', label: 'Tankstelle' },
      { key: 'shower', label: 'Duschen' },
      { key: 'picnicArea', label: 'Picknickbereich' },
      { key: 'kiosk', label: 'Kiosk' },
      { key: 'atm', label: 'Geldautomat' },
      { key: 'vendingMachine', label: 'Automaten' },
    ];

    const amenities: string[] = [];
    if (details) {
      for (const entry of amenityMap) {
        const val = details[entry.key];
        if (typeof val === 'boolean' && val) {
          amenities.push(entry.label);
        }
      }
    }

    const top = amenities.slice(0, 3);
    const fee = details?.isFee ? ' (WC gebührenpflichtig)' : '';

    if (top.length > 1) {
      const last = top.pop();
      const list = `${top.join(', ')} und ${last}`;
      return `Noch keine Bewertungen – aber die Ausstattung kann sich sehen lassen: ${list}.${fee} Schreib die erste Bewertung!`;
    } else if (top.length === 1) {
      return `Noch keine Bewertungen – ${name} bietet ${top[0]}.${fee} Schreib die erste Bewertung!`;
    }

    return `Noch keine Bewertungen – hilf anderen Fahrer:innen mit deiner ersten Einschätzung.${fee}`;
  }

  protected readonly environment = environment;
}
